
import api from './axios';
export const getMyProfileApi = (id) => api.get(`/profile/me/${id}`);

export const changePasswordApi = (user, payload) => {
    console.log("id, payload", user, payload);
    api.put(`/profile/password/${user.id}`, payload);
}

